import { locales, getLocalized, validateLocale } from '../locales'

/*
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
*/
type DayNameFormat = 'narrow' | 'short' | 'abbreviated' | 'wide'

interface IDayNameBuilderProps {
  format: DayNameFormat
  locale?: string
}

function dayNameBuilder({ format, locale }: IDayNameBuilderProps) {
  const requestedLocale = getLocalized(locale)
  const validLocale = validateLocale(locale)

  let weekStartsOn = (locales[validLocale].options && locales[validLocale].options.weekStartsOn) || 0

  const days = []
  for (let d = 0; d < 7; d++) {
    days.push(requestedLocale.day(d, { width: format }))
  }

  while (weekStartsOn > 0) {
    days.push(days.shift())
    weekStartsOn--
  }

  return days
}

export default dayNameBuilder
